import ACTIONS from "../actions";

const initialState = {
  delEdit: null,
  update_id: null,
  search: "",
  isViewed: 0,
};

const utilReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.DEL_Edit:
      return {
        ...state,
        delEdit: action.payload,
      };
    case ACTIONS.UPDATE_EDIT:
      return {
        ...state,
        update_id: action.payload,
      };
    case ACTIONS.UPDATE_IS_VIEWED:
      return {
        ...state,
        isViewed: action.payload,
      };

    case ACTIONS.IS_SEARCH:
      return {
        ...state,
        search: action.payload,
      };

    default:
      return state;
  }
};

export default utilReducer;
